// eslint-disable-next-line import/prefer-default-export
export const typeOfAssetOptions = [
  { i18nKey: 'brokerDealer.opportunitiesPage.typeOfAssetOptions.eg', value: null },
  { i18nKey: 'brokerDealer.opportunitiesPage.typeOfAssetOptions.realState', value: 'real-estate' },
  { i18nKey: 'brokerDealer.opportunitiesPage.typeOfAssetOptions.equity', value: 'equity' },
  { i18nKey: 'brokerDealer.opportunitiesPage.typeOfAssetOptions.debt', value: 'debt' },
  { i18nKey: 'brokerDealer.opportunitiesPage.typeOfAssetOptions.other', value: 'other' },
];
